export const config = {
  //header_toolbar:64,menu_toolbar:50
  containerheaderMargin: 130,
  headerMargin: 160,
  //sidenav-container_md-card_button:34
  containerButtonMargin: 60,
  containerPlaceHolderMargin: 40,
  containerButtonDubleMargin: 80,
  containerButtonTripleMargin: 160,
  containerButtonForthMargin: 240,

  //wait miliseconds for getting the session (header ngOnInit)
  waitMsForSessionInHeaderNgOnInit: 550,
  //wait miliseconds for getting the session (header verifyOwner)
  waitMsForSessionInHeaderVerifyOwner: 550,
  //wait miliseconds for getting the session (header verifyLogin)
  waitMsForSessionInHeaderVerifyLogin: 500,
  //wait miliseconds for getting the session (http.service)
  waitMsForSessionInHttpService: 500,
  //wait miliseconds for executing the search (ngAfterViewInit)
  waitMsForSearchInNgAfterViewInit: 600,
  rowsPerPageSize: 500,
};



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/util/config.ts